import type { FreightTypeKey } from "./types";

/**
 * The freight type id the tenant configures for `key` (the row `freight_<key>`, served by
 * useConfig("freight") as `<key>`), or null when it has none.
 *
 * Never 0: freight created from an invoice or sales order sent `type_misc ?? 0`, and no
 * tenant has `freight_type_misc` (g2 / mustang / peak / demo, live read 2026-10-08), so
 * every such freight was saved with the made-up type 0 (config-gate audit A12). Null is
 * the honest "no type" the API already accepts (FreightBase.type_id is Optional).
 */
export function freightTypeId(
  freightConfig: { [key: string]: any } | undefined,
  key: FreightTypeKey
): number | null {
  const raw = freightConfig?.[key];
  const id = typeof raw === "number" ? raw : typeof raw === "string" && raw.trim() !== "" ? Number(raw) : NaN;
  return Number.isInteger(id) && id > 0 ? id : null;
}
